import { defineStore } from 'pinia';
import { useThingsboard } from '~/composables/useThingsboard'

export const useUsersStore = defineStore('users',{
  state: () => ({
  }),
  actions: {
    async login(username: string, password: string): Promise<boolean> {
      try {
        await useThingsboard().login(username, password);
        return true;
      } catch (error) {
        throw Error('Nieprawidłowy użytkownik lub hasło');
      }
    },

    async logout(): Promise<boolean> {
      await useThingsboard().logout();
      return true;
    },
  },
})